<template>
  <main class="bg-main">
    <div class="py-12 md:px-12 lg:px-14 p-4 max-w-screen-2xl mx-auto">
      <div
        class="flex flex-col lg:flex-row items-center justify-center gap-10 lg:gap-52"
      >
        <!-- First Image -->
        <div class="lg:w-1/4 w-full flex justify-center">
          <img
            src="../assets/images/couple2.jpeg"
            alt="First Image"
            class="rounded-full object-cover w-40 h-40 lg:w-72 lg:h-72"
          />
        </div>

        <!-- Second Image -->
        <div class="lg:w-1/4 w-full flex justify-center mt-4 lg:mt-0">
          <img
            src="../assets/images/couple1.jpeg"
            alt="Second Image"
            class="rounded-full object-cover w-40 h-40 lg:w-72 lg:h-72"
          />
        </div>
      </div>

      <!-- Text Content (Centered) -->
      <div class="flex items-center justify-center mt-4 lg:-mt-28">
        <div class="lg:w-1/2 w-full">
          <div class="bg-white shadow p-6">
            <p class="mb-4">
              Behind every successful man is a God-given partner, and for Barka, family is the cornerstone of his life. As a devoted husband, inspiring mentor and visionary leader, he draws strength and purpose from making his family proud and ensuring their success.
            </p>
            <p class="mb-4">
              Barka's remarkable success is rooted in his ability to balance work and home, creating a harmonious life built on love, faith and peace.
            </p>
            <p class="mb-4">
              Guided by God, he has built a legacy where family remains at the heart of his achievements.
            </p>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
export default {};
</script>

<style scoped></style>
